import AutosizeTextarea from "@/components/Common/forms/AutosizeTextarea";
import clsxm from "@/lib/clsxm";
import {RATING_COMMENT_MAX_CHARS} from "@/store/constants";
import {type FC} from "react";
import {useTranslation} from "react-i18next";

const RatingCommentInput: FC<{
  className?: string;
  comment: string;
  firstName?: string;
  onChange: (comment: string) => void;
}> = ({className, comment, firstName, onChange}) => {
  const {t} = useTranslation("campaign_reporting");

  return (
    <div className={clsxm("flex w-full flex-col gap-1", className)}>
      <AutosizeTextarea
        className="p-3 text-sm md:placeholder:text-sm"
        maxLength={RATING_COMMENT_MAX_CHARS}
        maxRows={6}
        minRows={3}
        onChange={event => onChange(event.target.value)}
        optional
        placeholder={t("rating_comment_placeholder", {influencerName: firstName})}
        title={t("rating_comment_title")}
        value={comment}
      />
      <div className="text-neutral-grey-dark flex justify-between gap-3 text-xs">
        <span>{t("rating_comment_visibility", {influencerName: firstName})}</span>
        <span className={clsxm("shrink-0", comment.length >= RATING_COMMENT_MAX_CHARS && "text-danger-dark-red")}>
          {comment.length} / {RATING_COMMENT_MAX_CHARS}
        </span>
      </div>
    </div>
  );
};

export default RatingCommentInput;
